import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import webservice from '../../../../Service/webservice';
import { AesDecrypt, AesEncrypt } from "../../../../Service/crypto";
import api from '../../../../api';

export const fetchTicketDatas = createAsyncThunk('Email/fetchTicketDatas', async (data:any) => {

  const response = await api.fetch('api/Email-fetchTicketDatas', {
    method: 'POST',
    body: JSON.stringify({ data })
  })
  .then((response1) => response1.json())
  
  const TempData = response
  return TempData;
})